import { createChampionship } from './create-championship';
import { getChampionshipStats } from './get-championship-stats';
import { getParticipantInfo } from './get-participant-info';
import { getParticipantChampionshipsStatus } from './get-participant-championships-status';
import { getParticipantChampionships } from './get-participant-championships';
import { getActiveChampionships } from './get-active-championships';
import { addChallengeToChampionship } from './add-challenge-to-championship';
import { getChampionshipsNavigation } from './get-championships-navigation';
import { getOpenParticipantChampionshipsStatus } from './get-open-participant-championships-status';
import { deleteChampionship } from './delete-championship';

const ChampionshipService = {
  createChampionship,
  deleteChampionship,
  getActiveChampionships,
  getChampionshipStats,
  getParticipantInfo,
  getParticipantChampionshipsStatus,
  getParticipantChampionships,
  addChallengeToChampionship,
  getChampionshipsNavigation,
  getOpenParticipantChampionshipsStatus,
};

export default ChampionshipService;
